<template>
  <div class="content">
    <!-- 添加loading遮罩，当project_code无效时显示 -->
    <div class="loading-overlay" v-if="!isProjectCodeValid">
      <div class="loading-container">
        <img src="data:image/svg+xml;base64,PHN2ZyBkYXRhLXYtYzFhZmFhNDU9IiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgdmlld0JveD0iMCAwIDI0IDI0IiBjbGFzcz0ic3ZnIj48Y2lyY2xlIGN4PSIxOCIgY3k9IjEyIiByPSIwIiBmaWxsPSIjMzMzMzMzIj48YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJyIiBiZWdpbj0iLjY3IiBjYWxjTW9kZT0ic3BsaW5lIiBkdXI9IjEuNXMiIGtleVNwbGluZXM9IjAuMiAwLjIgMC40IDAuODswLjIgMC4yIDAuNCAwLjg7MC4yIDAuMiAwLjQgMC44IiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgdmFsdWVzPSIwOzI7MDswIi8+PC9jaXJjbGU+PGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMCIgZmlsbD0iIzMzMzMzMyI+PGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iciIgYmVnaW49Ii4zMyIgY2FsY01vZGU9InNwbGluZSIgZHVyPSIxLjVzIiBrZXlTcGxpbmVzPSIwLjIgMC4yIDAuNCAwLjg7MC4yIDAuMiAwLjQgMC44OzAuMiAwLjIgMC40IDAuOCIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIHZhbHVlcz0iMDsyOzA7MCIvPjwvY2lyY2xlPjxjaXJjbGUgY3g9IjYiIGN5PSIxMiIgcj0iMCIgZmlsbD0iIzMzMzMzMyI+PGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iciIgYmVnaW49IjAiIGNhbGNNb2RlPSJzcGxpbmUiIGR1cj0iMS41cyIga2V5U3BsaW5lcz0iMC4yIDAuMiAwLjQgMC44OzAuMiAwLjIgMC40IDAuODswLjIgMC4yIDAuNCAwLjgiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiB2YWx1ZXM9IjA7MjswOzAiLz48L2NpcmNsZT48L3N2Zz4=" 
        alt="加载中" style="width: 64px; height: 64px;">
        <div class="error-message">页面加载错误</div>
      </div>
    </div>
    
    <!-- 只有当project_code有效时才显示主要内容 -->
    <div class="mobile" v-if="width<800 && isProjectCodeValid">
      <div class="top_logo" v-if="showLogo">
        <img :src="logoSrc" alt="">
      </div>
      <div class="kf_img">
        <img src="../assets/img/kf1.png" alt="">
      </div>
      <div class="detail">
        <div class="detail_top">
          <div class="left_icon">
            <img src="../assets/img/tp.png" alt="">
          </div>
          <div class="content_title">
            <div class="title_top">{{serviceTimeText}}</div>
            <div class="title_bottom">夜间可留言,将优先跟进处理</div>
          </div>
        </div>
        <div class="detail_content">
          <div class="chat_content"  v-for="(item,index) in chatData" :key="index">
            <div class="customer" v-if="item.customs">
              <div class="customer_lie">
                <div class="customer_icon">
                  <img src="../assets/img/lt1.png" alt="">
                </div>
                <div class="customer_content">
                  <div class="loading-indicator" v-if="item.customs.loading">
                    <span>正在思考</span>
                    <img src="data:image/svg+xml;base64,PHN2ZyBkYXRhLXYtYzFhZmFhNDU9IiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgdmlld0JveD0iMCAwIDI0IDI0IiBjbGFzcz0ic3ZnIj48Y2lyY2xlIGN4PSIxOCIgY3k9IjEyIiByPSIwIiBmaWxsPSIjMzMzMzMzIj48YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJyIiBiZWdpbj0iLjY3IiBjYWxjTW9kZT0ic3BsaW5lIiBkdXI9IjEuNXMiIGtleVNwbGluZXM9IjAuMiAwLjIgMC40IDAuODswLjIgMC4yIDAuNCAwLjg7MC4yIDAuMiAwLjQgMC44IiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgdmFsdWVzPSIwOzI7MDswIi8+PC9jaXJjbGU+PGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMCIgZmlsbD0iIzMzMzMzMyI+PGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iciIgYmVnaW49Ii4zMyIgY2FsY01vZGU9InNwbGluZSIgZHVyPSIxLjVzIiBrZXlTcGxpbmVzPSIwLjIgMC4yIDAuNCAwLjg7MC4yIDAuMiAwLjQgMC44OzAuMiAwLjIgMC40IDAuOCIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIHZhbHVlcz0iMDsyOzA7MCIvPjwvY2lyY2xlPjxjaXJjbGUgY3g9IjYiIGN5PSIxMiIgcj0iMCIgZmlsbD0iIzMzMzMzMyI+PGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iciIgYmVnaW49IjAiIGNhbGNNb2RlPSJzcGxpbmUiIGR1cj0iMS41cyIga2V5U3BsaW5lcz0iMC4yIDAuMiAwLjQgMC44OzAuMiAwLjIgMC40IDAuODswLjIgMC4yIDAuNCAwLjgiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiB2YWx1ZXM9IjA7MjswOzAiLz48L2NpcmNsZT48L3N2Zz4=" 
                    alt="加载中" style="width: 24px; height: 24px;">
                  </div>
                  <div class="customer_message" v-for="(items,i) in item.customs.message" :key="i" v-html="items">
                  </div>
                  <div class="feedback-buttons" v-if="!item.customs.loading && item.customs.messageId">
                    <div class="feedback-button like" 
                          @click="sendFeedback(index, item.customs.feedback === 'like' ? '' : 'like')" 
                          :class="{ 'active': item.customs.feedback === 'like' }">
                      <img v-if="item.customs.feedback === 'like'" src="../assets/img/liked.png" alt="已点赞" />
                      <img v-else src="../assets/img/like.png" alt="点赞" />
                    </div>
                    <div class="feedback-button dislike" 
                          @click="sendFeedback(index, item.customs.feedback === 'dislike' ? '' : 'dislike')" 
                          :class="{ 'active': item.customs.feedback === 'dislike' }">
                      <img v-if="item.customs.feedback === 'dislike'" src="../assets/img/disliked.png" alt="已点踩" />
                      <img v-else src="../assets/img/dislike.png" alt="点踩" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="time" v-if="item.customs && item.customs.timestamp > 0">
              {{formatTime(item.customs.timestamp)}}
            </div>
            <div class="user" v-if="item.user">
              <div class="user_lie">
                <div class="user_icon">
                  <img src="../assets/img/yh.png" alt="">
                </div>
                <div class="user_content"  >
                  <div class="user_message" v-for="(j,k) in item.user.message" :key="k">
                    {{j}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="evaluate">
            <div class="question" @click="golink" v-if="showEvaluate && showUnsatisfiedLink">对回答不满意?点击跳转人工客服</div>
            <div class="score" v-if="showEvaluate">
              <div class="score_title">如果上面的内容有帮到你,请给AI小精灵评价一下吧~</div>
              <div class="score_content">
                <van-rate v-model="score"  @change="submitEvaluation" :class="{ 'no-pointer-events': evaluationDisabled }"/>
              </div>
            </div>
            <div class="service" v-if="showEvaluate">{{evaluationMsg}}</div>
            <div v-if="isSessionTimedOut || conversationEnd" class="timeout-message">
              <div class="newconversation"> {{isSessionTimedOut ? '长时间未收到您的消息，会话已结束。' : '本次服务已结束。'}}您可<span @click="startNewConversation">开启新会话</span></div>
            </div>
          </div>

        </div>
        <div class="detail_input">
          <div class="sending" @click="send" :class="{ 'disabled': isSending }" >
            <img src="../assets/img/fs.png" alt="">
          </div>
          <van-field
            v-model="value"
            type="textarea"
            rows="3"
            placeholder="请反馈您的问题,我们将尽快回复..."
            @keydown.enter="handleKeyDown"
            class="full-height-textarea"
          />
        </div>
        <div class="detial_message">
          <div class="detail_line"></div>
          <div class="message_title">常见问题</div>
          <div class="message_le">
            <div class="le_detail" v-for="(item,index) in messageDate" :key="index" @click="change(item.content)">
              {{item.content}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="Computer" v-if="width>=800 && isProjectCodeValid">
      <div class="top_logo" v-if="showLogo">
        <img :src="logoSrc" alt="">
      </div>
      <div class="computer_content">
        <div class="left_content">
          <div class="left_top">
            <div class="left_icon">
              <img src="../assets/img/kf1.png" alt="">
            </div>
            <div class="left_name">
              GM-01
            </div>
          </div>
          <div class="left_detail">
            <div class="detail_content">
              <div class="chat_content"  v-for="(item,index) in chatData" :key="index">
                <div class="customer" v-if="item.customs">
                  <div class="customer_lie">
                    <div class="customer_icon">
                      <img src="../assets/img/lt1.png" alt="">
                    </div>
                    <div class="customer_content">
                      <div class="loading-indicator" v-if="item.customs.loading">
                        <span>正在思考</span>
                        <img src="data:image/svg+xml;base64,PHN2ZyBkYXRhLXYtYzFhZmFhNDU9IiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgdmlld0JveD0iMCAwIDI0IDI0IiBjbGFzcz0ic3ZnIj48Y2lyY2xlIGN4PSIxOCIgY3k9IjEyIiByPSIwIiBmaWxsPSIjMzMzMzMzIj48YW5pbWF0ZSBhdHRyaWJ1dGVOYW1lPSJyIiBiZWdpbj0iLjY3IiBjYWxjTW9kZT0ic3BsaW5lIiBkdXI9IjEuNXMiIGtleVNwbGluZXM9IjAuMiAwLjIgMC40IDAuODswLjIgMC4yIDAuNCAwLjg7MC4yIDAuMiAwLjQgMC44IiByZXBlYXRDb3VudD0iaW5kZWZpbml0ZSIgdmFsdWVzPSIwOzI7MDswIi8+PC9jaXJjbGU+PGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMCIgZmlsbD0iIzMzMzMzMyI+PGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iciIgYmVnaW49Ii4zMyIgY2FsY01vZGU9InNwbGluZSIgZHVyPSIxLjVzIiBrZXlTcGxpbmVzPSIwLjIgMC4yIDAuNCAwLjg7MC4yIDAuMiAwLjQgMC44OzAuMiAwLjIgMC40IDAuOCIgcmVwZWF0Q291bnQ9ImluZGVmaW5pdGUiIHZhbHVlcz0iMDsyOzA7MCIvPjwvY2lyY2xlPjxjaXJjbGUgY3g9IjYiIGN5PSIxMiIgcj0iMCIgZmlsbD0iIzMzMzMzMyI+PGFuaW1hdGUgYXR0cmlidXRlTmFtZT0iciIgYmVnaW49IjAiIGNhbGNNb2RlPSJzcGxpbmUiIGR1cj0iMS41cyIga2V5U3BsaW5lcz0iMC4yIDAuMiAwLjQgMC44OzAuMiAwLjIgMC40IDAuODswLjIgMC4yIDAuNCAwLjgiIHJlcGVhdENvdW50PSJpbmRlZmluaXRlIiB2YWx1ZXM9IjA7MjswOzAiLz48L2NpcmNsZT48L3N2Zz4=" 
                        alt="加载中" style="width: 24px; height: 24px;">
                      </div>
                      <div class="customer_message" v-for="(items,i) in item.customs.message" :key="i" v-html="items">
                      </div>
                      <div class="feedback-buttons" v-if="!item.customs.loading && item.customs.messageId">
                        <div class="feedback-button like" 
                              @click="sendFeedback(index, item.customs.feedback === 'like' ? '' : 'like')" 
                              :class="{ 'active': item.customs.feedback === 'like' }">
                          <img v-if="item.customs.feedback === 'like'" src="../assets/img/liked.png" alt="已点赞" />
                          <img v-else src="../assets/img/like.png" alt="点赞" />
                        </div>
                        <div class="feedback-button dislike" 
                              @click="sendFeedback(index, item.customs.feedback === 'dislike' ? '' : 'dislike')" 
                              :class="{ 'active': item.customs.feedback === 'dislike' }">
                          <img v-if="item.customs.feedback === 'dislike'" src="../assets/img/disliked.png" alt="已点踩" />
                          <img v-else src="../assets/img/dislike.png" alt="点踩" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="time" v-if="item.customs && item.customs.timestamp > 0">
                  {{formatTime(item.customs.timestamp)}}
                </div>
                <div class="user" v-if="item.user">
                  <div class="user_lie">
                    <div class="user_icon">
                      <img src="../assets/img/yh.png" alt="">
                    </div>
                    <div class="user_content"  >
                      <div class="user_message" v-for="(j,k) in item.user.message" :key="k">
                        {{j}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="evaluate">
                <div class="question" @click="golink" v-if="showEvaluate && showUnsatisfiedLink">对回答不满意?点击跳转人工客服</div>
                <div class="score" v-if="showEvaluate">
                  <div class="score_title">如果上面的内容有帮到你,请给AI小精灵评价一下吧~</div>
                  <div>
                    <van-rate v-model="score"  @change="submitEvaluation" :class="{ 'no-pointer-events': evaluationDisabled }"/>
                  </div>
                </div>
                <div class="service" v-if="showEvaluate">{{evaluationMsg}}</div>
                <div v-if="isSessionTimedOut || conversationEnd" class="timeout-message">
                  <div class="newconversation"> {{isSessionTimedOut ? '长时间未收到您的消息，会话已结束。' : '本次服务已结束。'}}您可<span @click="startNewConversation">开启新会话</span></div>
                </div>
              </div>
              
            </div>
            <div class="detail_input">
              <div class="sending" @click="send" :class="{ 'disabled': isSending }" >
                <img src="../assets/img/fs.png" alt="">
              </div>
              <van-field
                v-model="value"
                type="textarea"
                rows="5"
                placeholder="请反馈您的问题,我们将尽快回复..."
                @keydown.enter="handleKeyDown"
                class="full-height-textarea"
              />
            </div>
          </div>
        </div>
        <div class="right_content">
          <div class="right_top">
            <div class="top_icon">
              <img src="../assets/img/mmkf.png" alt="">
            </div>
            <div class="top_artificial">
              <div class="artificial_left">联系人工：</div>
              <div class="artificial_right" @click="golink" :class="{ 'disabled': !artificialEnabled }">点击沟通</div>
            </div>
            <div class="top_time">
              <div class="time_left">
                工作时间：
              </div>
              <div class="time_right">
                <span class="time_line">
                  {{serviceTimeText}}
                </span>
                夜间可留言，将优先跟进处理
              </div>
            </div>
          </div>
          <div class="right_line"></div>
          <div class="right_bottom">
            <div class="bottom_title">
              常见问题
            </div>
            <div class="bottom_content">
              <div class="content_line" v-for="(item,index) in messageDate" :key="index">
                <div class="line_message"  @click="change(item.content)">{{item.content}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      num: 0,
      list: [],
      value: "",
      score:0,
      chatData:[
        // {
        //   customs:{
        //     message:[
        //         '您好~您已经进入智能AI服务页面,请描述您的问题.',
        //         '您好~请问有什么可以帮助到您的?'
        //     ]
        //   },
        //   user:{
        //     message:[
        //         '游戏突然闪退了怎么办?'
        //     ]
        //   }
        // }
      ],
      messageDate:[
        {
          content:'游戏卡顿,延迟如何解决?'
        },
        {
          content:'账号异常登录(异地IP保护解除方法)'
        },
        {
          content:'充值兑换失败或未到账处理流程'
        },
        {
          content:'充值已兑换失败或未到账处理流程'
        }
      ],
      chatId: '',
      closeByUser: false,
      conversationEnd: false,
      showEvaluate: false,
      showEvaluateInTime: process.env.VUE_APP_SHOWEVALUATEINTIME,
      evaluationMsg: '',
      evaluationDisabled: false,
      isSending: false,
      lastMessageTime: null, // 记录最后发送消息的时间
      evaluationTimeout: null, // 定时器标识符
      width:0,
      currentStreamMessage: null,
      socket: null,  // WebSocket实例
      reconnectTimer: null,  // 重连计时器
      connecting: false,  // 连接状态
      // 人工客服配置相关变量
      artificialEnabled: false, // 默认人工客服不可用
      showUnsatisfiedLink: false, // 默认不显示不满意链接
      serviceTimeText: '10:00~18:00', // 默认服务时间文本
      // logo相关变量
      showLogo: false, // 默认不显示logo
      logoSrc: '', // logo图片路径
      projectCode: '', // 项目代码，默认为空
      isProjectCodeValid: false, // 控制project_code是否有效
      // 会话超时相关变量
      inactivityTimer: null,
      lastActivityTime: Date.now(),
      sessionTimeout: 5 * 60 * 1000, // 5分钟超时
      isSessionTimedOut: false,
      jumpArtificialUrl: '',
    };
  },
  mounted() {
    this.width = window.innerWidth; // 屏幕宽度
    this.getProjectCode(); // 获取URL参数并验证project_code
    // 只有当project_code有效时才初始化WebSocket
    if (this.isProjectCodeValid) {
      this.initWebSocket();
      this.startInactivityTimer(); // 启动超时检测
    }
  },
  beforeDestroy() {
    this.closeWebSocket();
    if (this.evaluationTimeout) {
      clearTimeout(this.evaluationTimeout); 
    }
    if (this.inactivityTimer) {
      clearInterval(this.inactivityTimer); // 清除超时检测计时器
    }
  },
  methods: {
    // 获取URL参数project_code并严格校验
    getProjectCode() {
      let projectCode = this.$route.query.project_code;
      
      console.log("获取到的project_code: " + projectCode);
      
      // 严格校验project_code是否有效
      const validCodes = ['thsy', 'th1', 'th2', 'tianshi', 'yujian'];
      if (projectCode && validCodes.includes(projectCode)) {
        this.projectCode = projectCode;
        this.isProjectCodeValid = true;
        
        // 设置logo路径
        try {
          this.logoSrc = require(`../assets/img/logo-${this.projectCode}.png`);
          this.showLogo = true;
        } catch (e) {
          console.error(`Logo for project code ${this.projectCode} not found`, e);
          this.showLogo = false;
        }
      } else {
        // project_code无效，不再继续处理 
        this.isProjectCodeValid = false;
        console.error('Invalid project code:', projectCode);
      }
    },
    // 跳转人工客服
    golink(){
      // 如果人工客服不可用，则不执行跳转
      if (!this.artificialEnabled) {
        return;
      }
      
      // 发送跳转事件到后端
      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        this.socket.send(JSON.stringify({
          act: 'jumpArtificial',
          chatId: this.chatId
        }));
      }
      
      const chatId = this.chatId;
      const webUrl = process.env.VUE_APP_WEB_URL;
      // 字段来源：智齿后台CRM-设置-客户字段，查看对应的字段ID
      const params = {
        "3fb995fd1f7e413f9878d43b50c1e601": webUrl + "/#/chatHistory?chatId=" + chatId, 
      }
      // 在新窗口打开,注意需要urlencode
      window.open(this.jumpArtificialUrl + `&customer_fields=` + encodeURIComponent(JSON.stringify(params)), '_blank');
    },
    // 无帮助
    Nohelp() {

    },
    // 有帮助
    helpful(){

    },
    // 发送消息
    send() {
      if (this.isSending) return; // 防止重复点击
      if (!this.value || this.value.trim() === '') return;

      this.resetInactivityTimer(); // 重置超时计时器
      this.isSending = true; // 开始发送时置灰按钮

      // 清除之前的定时器
      if (this.evaluationTimeout) {
        clearTimeout(this.evaluationTimeout);
      }

      // 更新最后发送时间
      this.lastMessageTime = Date.now();

      // 设置新的定时器：30秒后显示评价模块
      this.evaluationTimeout = setTimeout(() => {
        this.showEvaluate = true;
        // 根据人工客服配置决定是否显示不满意链接
        this.showUnsatisfiedLink = this.artificialEnabled;
        this.scrollToBottom();
      }, this.showEvaluateInTime);
          
      // 1. 添加用户消息到聊天记录
      const userMsg = {
        user: {
          message: [this.value]
        }
      };
      this.chatData.push(userMsg);

      // 评价模块显示之后继续发送消息，则隐藏评价模块
      if(this.showEvaluate){
        // 如果已评价，则重置评价状态
        if (this.evaluationDisabled == true){
          this.evaluationMsg = '';
          this.evaluationDisabled = false;
          this.score = 0;
        }
        this.showEvaluate = false;
        this.showUnsatisfiedLink = false;
      }

      // 2. 插入加载条目
      const loadingMessage = {
        customs: {
          timestamp: 0,
          loading: true // 标识为加载状态
        },
        isStream: false
      };
      this.chatData.push(loadingMessage);
      this.scrollToBottom();
      
      // 2. 发送消息到WebSocket
      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        const payload = {
          act: 'question',
          message: this.value,
          timestamp: Date.now()
        };
        this.socket.send(JSON.stringify(payload));
        this.value = ''; // 清空输入框
      } else {
        console.error('WebSocket未连接');
        this.isSending = false; // 连接失败立即恢复按钮
      }
    },
    //点击常见问题
    change(value){
      this.resetInactivityTimer(); // 点击常见问题时重置计时器
      this.value = value;
    },
    // WebSocket初始化
    initWebSocket() { 
      console.log("VUE_APP_WS_URL: "+process.env.VUE_APP_WS_URL);
      console.log("VUE_APP_WEB_URL: "+process.env.VUE_APP_WEB_URL);  
      if (!this.socket || this.socket.readyState !== WebSocket.OPEN) {
        const wsUrl = process.env.VUE_APP_WS_URL;
        this.socket = new WebSocket(wsUrl);
        
        this.socket.onopen = () => {
          console.log('WebSocket连接成功');
          this.connecting = true;
          this.clearReconnectTimer();
          // 获取本地存储chatId值，发送到服务器
          const chatId = this.getChatId();
          this.socket.send(JSON.stringify({ act: 'login', 'chatId': chatId, 'project_code': this.projectCode, 'clientType': this.isMobile() ? 'h5' : 'pc' }));

          // 请求历史记录
          if (chatId) {
            this.socket.send(
              JSON.stringify({
                act: 'getHistory', 
                chatId: chatId,
              })
            );
          }
        };

        this.socket.onmessage = (event) => {
          const data = JSON.parse(event.data);
          
          // 处理配置信息
          if (data.type === 'config') {
            this.handleConfigData(data);
            return;
          }
          
          this.addMessageToChat(data);
        };

        this.socket.onerror = (error) => {
          console.error('WebSocket错误:', error);
          this.reconnect();
        };

        this.socket.onclose = (event) => {
          console.log('WebSocket关闭:', event);
          this.connecting = false;
          this.reconnect();
        };
      }
    },
    // 重连逻辑
    reconnect() {
      if (!this.reconnectTimer && !this.closeByUser) {
        const retryDelay = 3000; // 3秒重连
        this.reconnectTimer = setTimeout(() => {
          this.initWebSocket();
        }, retryDelay);
      }
    },
    
    // 关闭连接
    closeWebSocket() {
      if (this.socket) {
        this.socket.close();
        this.clearReconnectTimer();
        this.closeByUser = true;
      }
    },

    // 判断当前浏览器是PC还是移动端
    isMobile() {
      const userAgent = navigator.userAgent.toLowerCase();
      const isMobileDevice = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
      
      // 检查屏幕宽度
      const isMobileWidth = window.innerWidth <= 800;
      
      // 同时考虑用户代理和屏幕宽度
      return isMobileDevice || isMobileWidth;
    },
    // 清除重连计时器
    clearReconnectTimer() {
      if (this.reconnectTimer) {
        clearTimeout(this.reconnectTimer);
        this.reconnectTimer = null;
      }
    },
    addMessageToChat(data) {
      this.resetInactivityTimer(); // 收到消息时重置计时器
      console.log('收到消息:', data);
      if (!data) return;

      // 处理流式消息结束事件
      if (data.event === 'message_end') {
        // 解析Markdown语法
        if (this.currentStreamMessage) {
          const messageIndex = this.currentStreamMessage.index;
          const messageContent = this.currentStreamMessage.accumulatedMessage;
          const parsedContent = this.parseMarkdown(messageContent);
          
          // 更新消息内容为解析后的HTML
          this.$set(
            this.chatData[messageIndex].customs.message,
            0,
            parsedContent
          );
        }
        this.currentStreamMessage = null; // 重置流式状态
        this.isSending = false; // 流式消息结束时恢复按钮
        this.scrollToBottom();
        return;
      }

      // 处理流式消息分片
      if (data.type === 'stream') {
        // 移除最近的加载条目
        const lastLoadingIndex = this.chatData.findIndex(item => item.customs?.loading);
        if (lastLoadingIndex !== -1) {
          this.chatData.splice(lastLoadingIndex, 1);
        }
        // 初始化流式消息条目
        if (!this.currentStreamMessage) {
          const newMessage = {
            customs: {
              timestamp: data.timestamp !== undefined ? data.timestamp : null,
              messageId: data.messageId,
              message: [''] // 初始空内容
            },
            isStream: true // 流式消息标记
          };
          this.chatData.push(newMessage);
          const index = this.chatData.length - 1;
          this.currentStreamMessage = {
            index: index,
            accumulatedMessage: '' // 累积消息内容
          };
        }

        // 累积当前分片内容
        this.currentStreamMessage.accumulatedMessage += data.message;
        // 实时更新聊天记录中的对应条目
        this.$set(
          this.chatData[this.currentStreamMessage.index].customs.message,
          0,
          this.currentStreamMessage.accumulatedMessage
        );
        return;
      } else if (data.type === 'login') {
        // 保存返回的chatId到本地缓存
        this.setChatId(data.chatId);
        this.chatId = data.chatId;
      } else if (data.type === 'history') {
        const historyMessages = data.history || [];
        historyMessages.forEach(msg => {
          this.chatData.push({
            user: {
              timestamp: msg.add_time,
              message: [this.parseMarkdown(msg.user_message)]
            }
          });
          this.chatData.push({
            customs: {
              feedback: msg.feedback,
              messageId: msg.id,
              timestamp: msg.add_time,
              message: [this.parseMarkdown(msg.response)]
            }
          });
        });

        // 滚动到底部
        this.scrollToBottom();
        return;
      }

      // 处理普通消息
      const newMessage = {
        customs: {
          timestamp: data.timestamp !== undefined ? data.timestamp : null,
          message: [this.parseMarkdown(data.message)]
        }
      };
      // 替换加载条目
      const lastLoadingIndex = this.chatData.findIndex(item => item.customs?.loading);
      if (lastLoadingIndex !== -1) {
        this.chatData.splice(lastLoadingIndex, 1, newMessage);
      } else {
        this.chatData.push(newMessage);
      }
      this.scrollToBottom();
      this.isSending = false;
    },

    // 提交评价
    submitEvaluation() {
      if (this.score === 0) return; // 忽略0分

      // 1. 发送评分到服务器
      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        this.socket.send(
          JSON.stringify({
            act: 'evaluation',
            score: this.score,
            chatId: this.getChatId(),
          })
        );
      }
      if (this.score >= 3) {
        this.evaluationMsg = '感谢您对AI小精灵的肯定,小精灵随时为您提供更贴心,更高效的帮助。';
      } else {
        this.evaluationMsg = '非常抱歉给您不佳体验，感谢反馈!您可联系人工客服。';
      }
      this.scrollToBottom();
      // 2. 清空chatId
      this.setChatId('');
      this.evaluationDisabled = true;
      this.conversationEnd = true;
      this.isSending = true;
      // 关闭WebSocket连接
      this.closeWebSocket();
    },

    // 开启新会话
    startNewConversation(){
      this.conversationEnd = false;
      this.isSending = false;
      this.chatData = [];
      this.evaluationMsg = '';
      this.evaluationDisabled = false;
      this.score = 0; 
      this.showEvaluate = false;
      this.isSessionTimedOut = false; // 重置超时状态
      this.initWebSocket();
      this.startInactivityTimer(); // 重新启动超时检测
    },

    // 解析Markdown
    parseMarkdown(text) {
      if (!text) return '';
      
      // 解析代码块
      text = text.replace(/```([^`]+)```/gs, '<pre><code>$1</code></pre>');

      // 解析行内代码
      text = text.replace(/`([^`]+)`/g, '<code>$1</code>');

      // 解析多级标题
      text = text.replace(/(#{1,6})\s*(.+)$/gm, (match, hashes, title) => {
        const level = hashes.length;
        return `<h${level}>${title}</h${level}>`;
      });

      // 解析引用块 (> quote)
      text = text.replace(/>\s*(.*?)$/gm, '<blockquote>$1</blockquote>'); 

      // 解析有序列表
      text = text.replace(/\d+\.\s+(.+)$/gm, '<li>$1</li>');
      //text = text.replace(/(<li>.+<\/li>)/g, '<ol>$1</ol>');

      // 解析无序列表
      text = text.replace(/-\s+(.+)$/gm, '<li>$1</li>');
      //text = text.replace(/(<li>.+<\/li>)/g, '<ul>$1</ul>');

      // 解析链接 [文本](URL)
      text = text.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank">$1</a>');

      // 解析粗体 **文本**
      text = text.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');

      // 解析斜体 *文本*
      text = text.replace(/\*([^*]+)\*/g, '<em>$1</em>');

      // 处理HTML转义
      // text = text.replace(/</g, '&lt;').replace(/>/g, '&gt;');

      // 解析换行符
      text = text.replace(/(\r\n|\n|\r)/g, '<br/>');

      return text;
    },
    
    // 格式化时间（时：分）
    formatTime(timestamp) {
      const date = new Date(timestamp * 1000);
      return date.getHours() + ':' + date.getMinutes().toString().padStart(2, '0');
    },
    
    // 滚动到底部
    scrollToBottom() {
      this.$nextTick(() => {
        const chatContainer = this.$el.querySelector('.detail_content');
        if (!chatContainer) return;

        // 平滑滚动动画配置
        const duration = 300; // 动画时长（毫秒）
        const start = chatContainer.scrollTop;
        const end = chatContainer.scrollHeight;
        const startTime = performance.now();

        const animate = (currentTime) => {
          const timeElapsed = currentTime - startTime;
          const progress = Math.min(timeElapsed / duration, 1);
          const delta = end - start;
          chatContainer.scrollTop = start + delta * progress;

          if (timeElapsed < duration) {
            requestAnimationFrame(animate);
          }
        };

        requestAnimationFrame(animate);
      });
    },
    handleError(errorMsg) {
      this.chatData.push({
        customs: {
          message: [`系统提示: ${errorMsg}`]
        }
      });
    },
    // 处理键盘事件
    handleKeyDown(event) {
      // 如果按下Ctrl+Enter或Shift+Enter，允许换行
      if (event.ctrlKey || event.shiftKey) {
        return; // 不阻止默认行为，允许插入换行符
      }
      
      // 如果只按下Enter键，则发送消息并阻止默认行为
      event.preventDefault();
      this.send();
    },
    // 发送反馈（点赞/点踩）
    sendFeedback(index, type) {
      // 确保消息存在
      if (!this.chatData[index] || !this.chatData[index].customs) return;
      
      // 获取消息ID或内容
      const messageId = this.chatData[index].customs.messageId || null;
      if (messageId === null) return;
      
      this.$set(this.chatData[index].customs, 'feedback', type);
      // 发送反馈到服务器
      if (this.socket && this.socket.readyState === WebSocket.OPEN) {
        this.socket.send(
          JSON.stringify({
            act: 'feedback',
            type: type == '' ? 'cancel' : type, // 'like' 或 'dislike'
            messageId: messageId,
            chatId: this.getChatId(),
            timestamp: Date.now()
          })
        );
      }
      
    },
    // 处理配置信息
    handleConfigData(data) {
      console.log('收到配置信息:', data);
      if (data.config) {
        const config = data.config;
        
        // 更新人工客服状态
        this.artificialEnabled = config.is_enabled === 1;
        this.jumpArtificialUrl = config.url;
        // 更新服务时间文本
        if (config.is_enabled === 1) {
          if (config.service_start_time && config.service_end_time) {
            this.serviceTimeText = `每日${config.service_start_time}~${config.service_end_time}为您服务，`;
          } else {
            this.serviceTimeText = '每日10:00~18:00为您服务，';  
          }
        } else {
          this.serviceTimeText = '当前暂无人工客服，';
        }
        
        
        // 如果显示评价区域，则根据人工客服配置决定是否显示不满意链接
        if (this.showEvaluate) {
          this.showUnsatisfiedLink = this.artificialEnabled;
        }
      }
    },
    // 获取chatId
    getChatId(){
      return localStorage.getItem(this.projectCode + '_chatId');
    },
    // 设置chatId
    setChatId(chatId){
      if (chatId != '') {
        localStorage.setItem(this.projectCode + '_chatId', chatId);
      } else {
        localStorage.removeItem(this.projectCode + '_chatId');
      }
    },

    // 会话超时相关方法
    startInactivityTimer() {
      this.lastActivityTime = Date.now();
      // 定时检查一次是否超时
      this.inactivityTimer = setInterval(() => {
        this.checkInactivity();
      }, 5000);
    },
    
    resetInactivityTimer() {
      this.lastActivityTime = Date.now();
      // 如果会话已超时，则不重置计时器
      if (!this.isSessionTimedOut) {
        this.isSessionTimedOut = false;
      }
    },
    
    checkInactivity() {
      const currentTime = Date.now();
      const elapsed = currentTime - this.lastActivityTime;
      
      // 如果超过5分钟无交互，且未评价，则终止会话
      if (elapsed >= this.sessionTimeout && !this.evaluationDisabled && !this.isSessionTimedOut) {
        this.handleTimeout();
      }
    },
    
    handleTimeout() {
      // 标记会话已超时
      this.isSessionTimedOut = true;
      this.isSending = true;
      this.setChatId('');
      // 清除超时检测计时器
      if (this.inactivityTimer) {
        clearInterval(this.inactivityTimer);
        this.inactivityTimer = null;
      }
      
      // 关闭WebSocket连接
      this.closeWebSocket();
      
      // 滚动到底部
      this.scrollToBottom();
    },
  }
};
</script>

<style lang="less" scoped>
.content{
  width: 100%;
  height: 100vh;
}
.no-pointer-events {
  pointer-events: none; 
}
.mobile{
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url("../assets/img/bgsj.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  .top_logo{
    display: flex;
    position: absolute;
    left: 0.2rem;
    top: 0.2rem;
    img{
      width: 2rem;
    }
  }
  .kf_img{
    position: absolute;
    right: 0.2rem;
    top: -0.1rem;
    display: flex;
    z-index: 100;
    img{
      width: 4rem;
    }
  }
  .detail{
    margin-top: 0.8rem;
    display: flex;
    position: relative;
    flex-direction: column;
    align-items: center;
    width: 95%;
    height: 85%;
    border-radius: 0.2rem;
    background-color: #f5f2f2;
    .detail_top{
      display: flex;
      width: 100%;
      height: 1.5rem;
      border-top-left-radius: 0.2rem;
      border-top-right-radius: 0.2rem;
      background-color: #7a83f4;
      align-items: center;
      .left_icon{
        display: flex;
        width: 1rem;
        height: 1rem;
        margin-left: 0.3rem;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .content_title{
        margin-left: 0.25rem;
        display: flex;
        flex-direction: column;
        font-size: 0.3rem;
        color: #fff;
        letter-spacing:0.02rem;
        //font-family:"Adobeht std";
        .title_top{
          margin-bottom: 0.05rem;
        }
      }
    }
    .detail_content::-webkit-scrollbar{
      display: none;
    }
    .detail_content{
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 0.5rem;
      width: 95%;
      height: calc(100% - 9rem);
      overflow-y: auto;
      position: relative;
      .chat_content{
        display: flex;
        flex-direction: column;
        width: 100%;
        word-break: break-all;

        .customer{
          width: 100%;
          display: flex;
          .customer_lie{
            display: flex;
            .customer_icon{
              display: flex;
              img{
                width: 1rem;
                height: 1rem;
              }
            }
            .customer_content{
              display: flex;
              flex-direction: column;
              margin-left: 0.15rem;
              .customer_message{
                display: block;
                line-height: 0.5rem;
                font-size: 0.3rem;
                padding: 0.2rem;
                background-color: #ffffff;
                color: #4f4f4f;
                border-radius: 0.15rem;
                margin-bottom: 0.3rem;
                letter-spacing: 0.02rem;
              }
              .loading-indicator {
                display: flex;
                // line-height: 0.5rem;
                justify-content: center;
                align-items: center;
                padding: 0.2rem;
                border-radius: 0.15rem;
                margin-bottom: 0.3rem;
                span{
                  color: #4f4f4f;
                  display: inline;
                  font-size: 0.25rem;
                }
                img{
                  margin-left: 5px;
                }
              }
            }
          }
        }
        .time{
          display: flex;
          justify-content: center;
          color: #9b9b9b;
          font-size: 0.3rem;
          margin-bottom: 0.2rem;
          margin-top: 0.3rem;
        }
        .user{
          width: 100%;
          display: flex;
          flex-direction: row-reverse;
          .user_lie{
            display: flex;
            flex-direction: row-reverse;
            .user_icon{
              display: flex;
              img{
                width: 1rem;
                height: 1rem;
              }
            }
            .user_content{
              display: flex;
              flex-direction: column;
              margin-right: 0.15rem;
              .user_message{
                display: flex;
                line-height: 1rem;
                font-size: 0.3rem;
                padding: 0 0.2rem;
                background-color: #7a83f4;
                color: #ffffff;
                border-radius: 0.15rem;
                margin-bottom: 0.3rem;
                letter-spacing: 0.02rem;
              }
            }
          }
        }
      }

    }
    .question{
      display: flex;
      color: #1b85fd;
      font-size: 0.25rem;
      letter-spacing: 0.02rem;
      text-decoration: underline;
      width: 70%;
      margin-bottom: 0.2rem;
    }
    .score{
      display: block;
      letter-spacing: 0.01rem;
      border-radius: 0.2rem;
      background-color: #e4e4e4;
      font-size: 0.28rem;
      padding: 0.2rem;
      margin-bottom: 0.1rem;
      .score_title{
        margin-bottom: 0.2rem;
      }
    }
    .service{
      display: block;
      letter-spacing: 0.01rem;
      font-size: 0.25rem;
      color: #abaaaa;
    }
    .newconversation{
      display: block;
      letter-spacing: 0.01rem;
      font-size: 0.25rem;
      color: #abaaaa;
      span{
        color: #1b85fd;
        cursor: pointer;
        margin-left: 5px;
      }
    }
    .detail_input{
      width:100%;
      display: flex;
      height: 3rem;
      border-radius: 0.2rem;
      position: absolute;
      bottom: 0;
      .van-cell{
        display: flex;
        border-radius: 0.2rem;
        padding: 10px 16px;
        height: 100%;
        width: 100%;

        .van-field__body{
          color: #ababab !important;
          letter-spacing: 0.02rem;
          height: 100%;
          width: 100%;
        }
        
        .van-field__control {
          height: 100% !important;
          resize: none;
        }
      }
      .sending{
        z-index: 1000;
        position: absolute;
        right: 0.4rem;
        top: 0.4rem;
        cursor: pointer;
        img{
          width: 1rem;
          height: 1rem;
        }
        &.disabled {
          opacity: 0.6;
          pointer-events: none;
          cursor: not-allowed;
        }
      }
    }
    .detial_message{
      width: 95%;
      display: flex;
      flex-direction: column;
      position: absolute;
      bottom: 3rem;
      background: #f5f2f2;
      .detail_line{
        height: 0.01rem;
        width: 100%;
        background-color: #dadada;
      }
      .message_title{
        margin-top: 0.2rem;
        font-size: 0.28rem;
        color: #5e5e5e;
      }
      .message_le{
        display: flex;
        justify-content: space-between;
        flex-flow:row wrap;
        margin-top: 0.2rem;
        margin-bottom: 0.4rem;
        align-content: flex-start;
        .le_detail{
          display: flex;
          justify-content: center;
          align-items: center;
          height: 0.8rem;
          color: #598bfe;
          background-color: #ffffff;
          padding:  0 0.3rem;
          border-radius: 0.5rem;
          margin-right: 0.2rem;
          margin-bottom: 0.2rem;
          font-size: 0.25rem;
        }
      }
    }
    .feedback-buttons {
      display: flex;
      margin-top:0;
      margin-bottom: 0.3rem;
      
      .feedback-button {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        margin-right: 0.2rem;
        cursor: pointer;
        transition: all 0.2s;
        
        &:hover {
          background-color: #e0e0e0;
        }
        
        &.active {
          background-color: #f0f0f0;
        }
        
        img {
          width: 0.5rem;
          height: 0.5rem;
        }
      }
    }
  }

}
.Computer{
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url("../assets/img/bg.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  .top_logo{
    position: absolute;
    left: 1%;
    top: 1%;
    width: 10%;
    img{
      width: 120px;
    }
  }
  .computer_content{
    display: flex;
    width: 70%;
    background-color: #f5f2f2;
    height: 85%;
    border-radius: 20px;
    .left_content{
      display: flex;
      width: 71%;
      height: 100%;
      overflow-y: hidden;
      flex-direction: column;
      .left_top{
        height: 90px;
        width: 100%;
        border-top-left-radius: 20px;
        background-color: #7a83f4;
        display: flex;
        align-items: center;
        .left_icon{
          margin-left: 10px;
          display: flex;
        }
        .left_name{
          margin-top: 15px;
          display: flex;
          font-size: 34px;
          font-weight: bold;
          color: #ffffff;
        }
      }
      .left_detail{
        display: flex;
        width: 100%;
        height: 100%;
        overflow: hidden;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
        .detail_content::-webkit-scrollbar{
          display: none;
        }
        .detail_content{
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          margin-top: 30px;
          width: 95%;
          height: calc(100% - 90px);
          padding-bottom: 200px;
          overflow-y: auto;
          position: relative;
          .chat_content{
            display: flex;
            flex-direction: column;
            width: 100%;
            word-break: break-all;
            .customer{
              width: 100%;
              display: flex;
              .customer_lie{
                display: flex;
                .customer_icon{
                  display: flex;
                  img{
                    width: 50px;
                    height:50px;
                  }
                }
                .customer_content{
                  display: flex;
                  flex-direction: column;
                  margin-left: 10px;
                  .customer_message{
                    display: block;
                    font-size: 20px;
                    margin-bottom: 10px;
                    padding: 15px 20px;
                    background-color: #ffffff;
                    color: #4f4f4f;
                    border-radius: 10px;
                    letter-spacing: 2px;
                  }
                  .loading-indicator {
                    display: flex;
                    // line-height: 1rem;
                    justify-content: center;
                    align-items: center; 
                    padding: 15px 10px;
                    border-radius: 0.15rem;
                    margin-bottom: 0.3rem;
                    span{
                      color: #4f4f4f;
                      display: inline;
                    }
                    img{
                      margin-left: 5px;
                    }
                  }
                }
              }
            }
            .time{
              display: flex;
              justify-content: center;
              color: #9b9b9b;
              font-size: 20px;
              margin-bottom: 10px;
              margin-top: 20px;
            }
            .user{
              width: 100%;
              display: flex;
              flex-direction: row-reverse;
              margin-bottom: 40px;
              .user_lie{
                display: flex;
                flex-direction: row-reverse;
                .user_icon{
                  display: flex;
                  img{
                    width: 50px;
                    height: 50px;
                  }
                }
                .user_content{
                  display: flex;
                  flex-direction: column;
                  margin-right: 0.15rem;
                  .user_message{
                    display: flex;
                    background-color: #7a83f4;
                    color: #ffffff;
                    font-size: 20px;
                    margin-bottom: 10px;
                    padding: 15px 20px;
                    border-radius: 10px;
                    letter-spacing: 2px;
                  }
                }
              }
            }
          }

        }
        .question{
          display: flex;
          color: #1b85fd;
          font-size: 15px;
          letter-spacing: 2px;
          text-decoration: underline;
          cursor: pointer;
          //margin-bottom: 0.2rem;
          // position: absolute;
          right: 13%;
          top: 47%;
          margin-left: 5px;
        }
        .content_help{
          font-size: 16px;
        }
        .help_cilck{
          margin-top: 10px;
          width: 45%;
          display: flex;
          align-items: center;
          color: #4f4f4f;
          .No_help{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 15px;
            cursor: pointer;
          }
          .helpful{
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
          }
          .title{
            margin-left: 5px;
          }
        }
        .score{
          display: block;
          flex-direction: column;
          letter-spacing: 0.01rem;
          border-radius: 0.05rem;
          background-color: #e4e4e4;
          padding: 0.05rem;
          margin-bottom: 0.02rem;
          margin-top: 0.02rem;
          width: 75%;
          .score_title{
            margin-bottom: 0rem;
            display: block;
            color: #555555;
            font-size: 14px;
            float: left;
          }
          .score_content { 
            display: block;
          }
        }
        .service{
          display: block;
          letter-spacing: 0.01rem;
          color: #abaaaa;
          margin-left: 5px;
        }
        .newconversation{
          display: block;
          letter-spacing: 0.01rem;
          color: #abaaaa;
          margin-left: 5px;
          span{
            color: #1b85fd;
            cursor: pointer;
            margin-left: 5px;
          }
        }
        .detail_input{
          width:98%;
          display: flex;
          height: 150px;
          border-radius: 10px;
          position: absolute;
          bottom: 1%;
          .van-cell{
            display: flex;
            border-radius: 15px;
            height: 100%;
            width: 100%;
            
            .van-field__body{
              color: #ababab !important;
              letter-spacing: 0.02rem;
              height: 100%;
              width: 100%;
            }
            
            .van-field__control {
              height: 100% !important;
              resize: none;
            }
          }
          .sending{
            z-index: 1000;
            position: absolute;
            right: 20px;
            top: 20px;
            cursor: pointer;
            img{
              width: 50px;
              height: 50px;
            }
            &.disabled {
              opacity: 0.6;
              pointer-events: none;
              cursor: not-allowed;
            }
          }
        }
      }
    }
    .right_content{
      width: 29%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      background-color: #e5e5e5;
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
      .right_top{
        width: 100%;
        height: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .top_icon{
          margin-top: 30px;
          display: flex;
          width: 35%;
          img{
            width: 100%;
          }
        }
        .top_artificial{
          display: flex;
          align-items: center;
          font-size: 20px;
          color: #5e5e5e;
          margin-top: 5%;
          .artificial_right{
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 35px;
            padding: 0 15px;
            background-color: #7a83f4;
            color: #ffffff;
            border-radius: 20px;
            
            &.disabled {
              background-color: #cccccc;
              color: #999999;
              cursor: not-allowed;
            }
          }
        }
        .top_time{
          margin-top: 10px;
          display: flex;
          flex-direction: column;
          font-size: 20px;
          color: #5e5e5e;
          width: 55%;
          .time_right{
            margin-top: 5%;
            font-size: 15px;
            letter-spacing: 1px;
            line-height: 25px;
            span{
              color: #7a83f4;
            }
          }
        }

      }
      .right_line{
        width: 100%;
        height: 1px;
        background-color: #cdcbcb;
      }
      .right_bottom{
        width: 100%;
        height: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .bottom_title{
          margin-top: 8%;
          width: 80%;
          display: flex;
          font-size: 22px;
          font-weight: bold;
          color: #5e5e5e;

        }
        .bottom_content{
          display: flex;
          flex-direction: column;
          width: 80%;
          margin-top: 20px;
          .content_line{
            display: flex;
            align-items: center;
            color: #a0a0a0;
            margin-bottom: 10px;
            font-size: 16px;
            .line_message{
              cursor: pointer;
              border-radius: 15px;
              border: 1px solid #bfbfbf;
              line-height: 30px;
              padding: 0 15px;
              background-color: #ffffff;
            }
          }
        }
      }
    }
  }
  .feedback-buttons {
    display: flex;
    margin-bottom: 15px;
    
    .feedback-button {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      margin-right: 5px;
      cursor: pointer;
      transition: all 0.2s;
      margin-left: 5px;
      
      img {
        width: 20px;
        height: 20px;
      }
    }
  }
}
.evaluate {
  margin-left: 60px;
  width: 90%;
}

// 添加全屏loading遮罩样式
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.error-message {
  margin-top: 20px;
  font-size: 16px;
  color: #333;
}
</style>